var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-select',{attrs:{"value":_vm.val,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"change":_vm.bindChange}},_vm._l((_vm.dropdownList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"disabled":_vm.disabled}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }